import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { apiBaseUrl } from "@/api/service";
import { orderBy } from "lodash";
import dayjs from "dayjs";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-company",
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      time: [],
      searchForm: {
        page: 1,
        count: 20,
        device_id: this.$route.query.device_id || "",
        user_id: this.$route.query.user_id || "",
        remark: "",
        risk_code: "",
        status: "",
        category: "",
        phone: this.$route.query.phone
        // start_date: '',
        // end_date: '',
      },
      // 搜索表单
      prevRiskCode: [],
      // 记录上一次的选择
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数
      importLoading: false,
      riskList: [],
      sourceList: [],
      dialogFormVisible: false,
      perception_database_id: "",
      currentRow: null,
      perceptionCode: {
        PHiuUt: "诈骗",
        orTPeJ: "中介/二房东"
      },
      dangerDialogVisible: false,
      category: "",
      categoryDialogVisible: false,
      moreUserDialogVisible: false,
      moreUserList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getRiskList();
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleRiskCodeChange: function handleRiskCodeChange(val) {
      var prev = this.prevRiskCode || [];
      var added = val.filter(function (v) {
        return !prev.includes(v);
      }); // 新增了哪些
      // const removed = prev.filter(v => !val.includes(v)); // 需要的话也能用

      var hasAll = val.includes(''); // 全部
      var hasAllRisk = val.includes('1'); // 全部风险

      // 同时存在两个“全选类”，按最近新增的来定夺
      if (hasAll && hasAllRisk) {
        if (added.includes('')) {
          this.searchForm.risk_code = [''];
        } else if (added.includes('1')) {
          this.searchForm.risk_code = ['1'];
        } else {
          // 理论上不会走到；兜底：保留上次已有的那个
          this.searchForm.risk_code = prev.includes('') ? [''] : ['1'];
        }
      }
      // 新增“全部” => 清空其他，只留“全部”
      else if (added.includes('')) {
        this.searchForm.risk_code = [''];
      }
      // 新增“全部风险” => 清空其他，只留“全部风险”
      else if (added.includes('1')) {
        this.searchForm.risk_code = ['1'];
      }
      // 已有“全部”，此时又新增了其他 => 去掉“全部”
      else if (hasAll && added.length) {
        this.searchForm.risk_code = val.filter(function (v) {
          return v !== '';
        });
      }
      // 已有“全部风险”，此时又新增了其他 => 去掉“全部风险”
      else if (hasAllRisk && added.length) {
        this.searchForm.risk_code = val.filter(function (v) {
          return v !== '1';
        });
      }
      // 其他正常情况
      else {
        this.searchForm.risk_code = val;
      }

      // 更新快照，防止下次判断失真
      this.prevRiskCode = _toConsumableArray(this.searchForm.risk_code);

      // 触发查询
      this.getData('search');
    },
    sortChange: function sortChange(row) {
      console.log(row);
      if (row.order == "descending") {
        this.searchForm.order = "-" + row.prop;
      } else if (row.order == "ascending") {
        this.searchForm.order = row.prop;
      } else {
        this.searchForm.order = "";
      }
      this.getData();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getRiskList: function getRiskList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getRiskList();
            case 1:
              res = _context2.v;
              _this2.riskList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.page = 1;
                _this3.searchForm.count = 20;
              }
              // if(this.time.length > 0) {
              //     this.searchForm.start_date = this.time[0]
              //     this.searchForm.end_date = this.time[1]
              // }else {
              //     this.searchForm.start_date = ''
              //     this.searchForm.end_date = ''
              // }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getDeviceIdList(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data = res.data.map(function (i) {
                i.user_list = orderBy(i.user_list, ["processed", "created_at"], ["asc", "desc"]);
                return i;
              });
              _context3.n = 2;
              return _this3.getUserListByIdsMore(res.data, "user_list", 'tableData');
            case 2:
              _this3.tableData = _context3.v;
              _this3.total = res.page.total;
              _this3.tableLoading = false;
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    remark: function remark(row) {
      var _this4 = this;
      var text = row.remark || (row.user_list.length > 0 ? row.user_list[0]["remark"] : "");
      this.$prompt("", "备注", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        inputValue: text,
        inputPattern: /\S/,
        inputErrorMessage: "请输入备注"
      }).then(function (_ref) {
        var value = _ref.value;
        _this4.$api.setDeviceIdRemark({
          id: row.id,
          action: 5,
          remark: value
        }).then(function (res) {
          _this4.$message({
            type: "success",
            message: "备注成功"
          });
          _this4.getData();
        });
      }).catch(function () {});
    },
    // 设置高危弹窗
    setDanger: function setDanger(row) {
      this.currentRow = row;
      this.category = row.category;
      this.dangerDialogVisible = true;
    },
    // 设置高危确认
    setDangerConfirm: function setDangerConfirm() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var danger;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this5.$api.setDeviceIdDanger({
                id: _this5.currentRow.id,
                action: 1
              });
            case 1:
              danger = _context4.v;
              // 操作上报
              _this5.$operationLog.push({
                code: 'highrisk',
                operationType: "user_device_id",
                detailBatchNo: _this5.currentRow.device_id || _this5.currentRow.mini_program_device_id
              });
              _this5.$message({
                type: "success",
                message: "设置成功"
              });
              if (!(_this5.category !== "")) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return _this5.$api.setDeviceIdDanger({
                id: _this5.currentRow.id,
                action: 6,
                category: _this5.category
              });
            case 2:
              // 操作上报
              _this5.$operationLog.push({
                code: 'category',
                operationType: "user_device_id",
                detailBatchNo: _this5.currentRow.device_id || _this5.currentRow.mini_program_device_id
              });
            case 3:
              _this5.dangerDialogVisible = false;
              _this5.getData();
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 移除高危
    removeDanger: function removeDanger(row) {
      var _this6 = this;
      this.$confirm("移除高危设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this6.$api.setDeviceIdDanger({
          id: row.id,
          action: 2
        }).then(function (res) {
          // 操作上报
          _this6.$operationLog.push({
            code: 'removehighrisk',
            operationType: "user_device_id",
            detailBatchNo: row.device_id || row.mini_program_device_id
          });
          _this6.$message({
            type: "success",
            message: "移除成功"
          });
          _this6.getData();
        });
      });
    },
    // async getSourceList(){
    //     let res = await this.$api.getDeviceIdSourceList();
    //     this.sourceList = res.data;
    // },
    // 打开感知源弹窗
    openSource: function openSource(row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this7.currentRow = row;
              _context5.n = 1;
              return _this7.$api.getDeviceIdSourceList();
            case 1:
              res = _context5.v;
              // 获取感知源数据库
              _this7.perception_database_id = row.perception_database_id;
              _this7.sourceList = res.data;
              _this7.dialogFormVisible = true;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 设置感知源
    setSource: function setSource() {
      var _this8 = this;
      this.$api.setDeviceIdSource({
        id: this.currentRow.id,
        action: 3,
        perception_database_id: this.perception_database_id
      }).then(function (res) {
        // 操作上报
        _this8.$operationLog.push({
          code: 'sensingsource',
          operationType: "user_device_id",
          detailBatchNo: _this8.currentRow.device_id || _this8.currentRow.mini_program_device_id
        });
        _this8.$message({
          type: "success",
          message: "设置成功"
        });
        _this8.getData();
        _this8.dialogFormVisible = false;
      });
    },
    // 移除感知源
    removeSource: function removeSource(row) {
      var _this9 = this;
      this.$confirm("移除感知源, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this9.$api.setDeviceIdSource({
          id: row.id,
          action: 4,
          perception_database_id: row.perception_database_id
        }).then(function (res) {
          // 操作上报
          _this9.$operationLog.push({
            code: 'removesensing',
            operationType: "user_device_id",
            detailBatchNo: row.device_id || row.mini_program_device_id
          });
          _this9.$message({
            type: "success",
            message: "移除成功"
          });
          _this9.getData();
        });
      });
    },
    // 设置类别弹窗
    setCategory: function setCategory(row) {
      this.currentRow = row;
      this.category = row.category;
      this.categoryDialogVisible = true;
    },
    // 设置类别确认
    setCategoryConfirm: function setCategoryConfirm() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this0.$api.setDeviceIdDanger({
                id: _this0.currentRow.id,
                action: 6,
                category: _this0.category
              });
            case 1:
              data = _context6.v;
              if (data.code == 200) {
                _this0.$message({
                  type: "success",
                  message: "设置成功"
                });
                _this0.categoryDialogVisible = false;
                _this0.getData();
              } else {
                _this0.$message.error("设置类别出错");
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    // 更多关联用户
    moreUser: function moreUser(list) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this1.moreUserList = JSON.parse(JSON.stringify(list));
              userIds = [];
              _this1.moreUserList.forEach(function (item) {
                item.created_at = dayjs(item.created_at * 1000).format("YYYY-MM-DD");
                if (userIds.indexOf(item.id) == -1) {
                  userIds.push(item.id);
                }
              });
              _context8.n = 1;
              return _this1.$api.getUsersTagList({
                top: 1,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context8.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      _this1.moreUserList.forEach(function (item, index) {
                        if (item.id == key) {
                          _this1.$set(item, "userTag", res.data[key] || []);
                        }
                      });
                    case 1:
                      return _context7.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context8.n = 4;
                break;
              }
              key = _t2.value;
              return _context8.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context8.n = 2;
              break;
            case 4:
              _this1.moreUserDialogVisible = true;
            case 5:
              return _context8.a(2);
          }
        }, _callee7);
      }))();
    }
  }
};